import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useMobileNavItems } from './nav-items';

export function MobileBottomNav() {
  const location = useLocation();
  const mobileNavItems = useMobileNavItems();

  const isActive = (path: string, exact?: boolean) =>
    exact ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/85 md:hidden">
      <div className="grid grid-cols-6 gap-1 px-2 pb-[calc(env(safe-area-inset-bottom)+0.4rem)] pt-2">
        {mobileNavItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path, item.exact);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex min-h-[3.5rem] min-w-0 flex-col items-center justify-center rounded-xl px-1 py-2 text-[11px] font-medium transition-colors',
                active
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground',
              )}
            >
              <Icon className="mb-1 h-4 w-4" />
              <span className="w-full truncate text-center">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
